import { useEffect } from 'react'
import Script from 'next/script'

const SocialShare = ({ className = '' }) => {
  useEffect(() => {
    if (window?.addthis?.layers) {
      window.addthis.layers.refresh()
    }
  }, [])

  return (
    <>
      <Script
        id="social-share"
        strategy="lazyOnload"
        src={`//s7.addthis.com/js/300/addthis_widget.js#pubid=${process.env.NEXT_PUBLIC_ADDTHIS_PUB_ID}`}
        onLoad={() => {
          if (window?.addthis) {
            window.addthis.init()
          }
        }}
      />

      <div className={`social-share ${className}`}>
        <div className="addthis_inline_share_toolbox" />
      </div>
    </>
  )
}

export default SocialShare